import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export async function deleteCoinFromBriefcase(coinId) {
  const url = `${backendUrl}/api/widgets/user-assets/?coin_id=${coinId}`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error(`Network error: HTTP ${response.status}`);
    }

    return true;
  } catch (error) {
    console.error('API deleteCoinFromBriefcase error:', error);
    throw error;
  }
}